import { useReportTemplateContext } from "../ReportTemplate/ReportTemplateContext";

const GREEN = "#04aa00";
const LIGHT_GREY = "#f0f0f0";
const WHITE = "#ffffff";

export default function PohjavesiBlock() {
  const { rakennusData: kiinteisto } = useReportTemplateContext();

  const rakennukset =
    kiinteisto?.rakennukset_fulls ||
    kiinteisto?.rakennukset ||
    [];

  const getRakennusLabel = rakennus =>
    rakennus.rakennustunnus ||
    rakennus.Rakennustunnus ||
    rakennus.id_rakennus ||
    "Rakennus";

  const renderValue = value => {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return "–";
    }

    return String(value);
  };

  return (
    <div
      className="rounded border overflow-hidden"
      style={{
        backgroundColor: WHITE,
        borderColor: "#e9f0ec"
      }}
    >
      <section>
        <div
          className="px-3 py-2 fw-bold text-white"
          style={{ backgroundColor: GREEN }}
        >
          Pohjavesialueet
        </div>

        {rakennukset.length === 0 ? (
          <div className="p-3 text-muted">
            Ei pohjavesitietoja saatavilla.
          </div>
        ) : (
          rakennukset.map((rakennus, rakennusIndex) => {
            const pohjavesialueet =
              rakennus.aluetiedot?.pohjavesi || [];

            return (
              <div
                key={
                  rakennus.id_rakennus ||
                  rakennus.rakennustunnus ||
                  rakennusIndex
                }
              >
                {rakennukset.length > 1 && (
                  <div
                    className="px-3 py-2 fw-bold"
                    style={{
                      backgroundColor: "#e2e2e2"
                    }}
                  >
                    Rakennus: {getRakennusLabel(rakennus)}
                  </div>
                )}

                <table className="table table-sm mb-0">
                  <tbody>
                    <tr>
                      <th
                        colSpan={2}
                        className="px-3 py-2"
                        style={{
                          backgroundColor: LIGHT_GREY,
                          border: 0
                        }}
                      >
                        Pohjavesialueet
                      </th>
                    </tr>

                    {pohjavesialueet.length > 0 ? (
                      pohjavesialueet.flatMap(
                        (pohjavesi, pohjavesiIndex) => {
                          const rows = [];

                          if (pohjavesialueet.length > 1) {
                            rows.push(
                              <tr
                                key={`pohjavesi-title-${pohjavesiIndex}`}
                              >
                                <th
                                  colSpan={2}
                                  className="px-3 py-2"
                                  style={{
                                    backgroundColor: "#fafafa",
                                    border: 0
                                  }}
                                >
                                  Pohjavesialue {pohjavesiIndex + 1}
                                </th>
                              </tr>
                            );
                          }

                          rows.push(
                            <tr
                              key={`pohjavesi-name-${pohjavesiIndex}`}
                            >
                              <th
                                className="px-3 py-2 fw-normal"
                                style={{
                                  width: "42%",
                                  backgroundColor: WHITE,
                                  border: 0
                                }}
                              >
                                Nimi
                              </th>

                              <td
                                className="px-3 py-2"
                                style={{
                                  backgroundColor: WHITE,
                                  border: 0
                                }}
                              >
                                {renderValue(pohjavesi.nimi)}
                              </td>
                            </tr>
                          );

                          if (pohjavesi.luokka) {
                            rows.push(
                              <tr
                                key={`pohjavesi-class-${pohjavesiIndex}`}
                              >
                                <th
                                  className="px-3 py-2 fw-normal"
                                  style={{
                                    backgroundColor: WHITE,
                                    border: 0
                                  }}
                                >
                                  Luokka
                                </th>

                                <td
                                  className="px-3 py-2"
                                  style={{
                                    backgroundColor: WHITE,
                                    border: 0
                                  }}
                                >
                                  {pohjavesi.luokka}
                                </td>
                              </tr>
                            );
                          }

                          if (pohjavesi.etäisyys) {
                            rows.push(
                              <tr
                                key={`pohjavesi-distance-${pohjavesiIndex}`}
                              >
                                <th
                                  className="px-3 py-2 fw-normal"
                                  style={{
                                    backgroundColor: WHITE,
                                    border: 0
                                  }}
                                >
                                  Etäisyys
                                </th>

                                <td
                                  className="px-3 py-2"
                                  style={{
                                    backgroundColor: WHITE,
                                    border: 0
                                  }}
                                >
                                  {pohjavesi.etäisyys}
                                </td>
                              </tr>
                            );
                          }

                          return rows;
                        }
                      )
                    ) : (
                      <tr>
                        <td
                          colSpan={2}
                          className="px-3 py-2"
                          style={{
                            backgroundColor: WHITE,
                            border: 0
                          }}
                        >
                          Kohde ei sijaitse pohjavesialueella.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {rakennusIndex < rakennukset.length - 1 && (
                  <div
                    style={{
                      height: 1,
                      backgroundColor: "#dddddd"
                    }}
                  />
                )}
              </div>
            );
          })
        )}
      </section>
    </div>
  );
}